import { FormEvent } from 'react';
import { advancedDefaults } from '../searchConfig';
import { AdvancedFilters } from '../types';
import { DonationCta } from './DonationCta';
import { SearchForm } from './SearchForm';

type SearchSectionProps = {
  advancedFilters: AdvancedFilters;
  category: string;
  query: string;
  showDonationCta: boolean;
  showAdvanced: boolean;
  onCategoryChange: (category: string) => void;
  onClearSearch: () => void;
  onQueryChange: (query: string) => void;
  onResetAdvancedFilters: () => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  onToggleAdvanced: () => void;
  onUpdateAdvancedFilter: (name: keyof typeof advancedDefaults, value: string) => void;
};

export function SearchSection(props: SearchSectionProps) {
  const { showDonationCta } = props;

  return (
    <section className="search-section" aria-label="GotConn search">
      <div className="brand-block">
        <h1>
          <span>GOT</span> Conn
        </h1>
        <p>Your Search, Your Choice</p>
      </div>

      <SearchForm {...props} />
      {showDonationCta && <DonationCta />}
    </section>
  );
}
